import { IWorkerProcess } from '../types/IWorkerProcess';
import { Request } from './Request';

export let WorkerStatusType = {
  active: 'active',
  activeSyncing: 'activesyncing',
  busy: 'busy',
  decommissionFailedReadOnly: 'decommissionfailedreadonly',
  decommissioningReadOnly: 'decommissioningreadonly',
  down:'down',
  passive: 'passive',
  readOnly: 'readonly',
  readyForRemoval: 'readyforremoval',
  statusNotAvailable: 'statusnotavailable',
  notAvailable: 'notavailable',
  unlicensed: 'unlicensed',
  external: 'external',
};

export interface IGetWorkerProcessStatusParams {
  process: IWorkerProcess;
}

export interface IGetWorkerProcessStatusResult {
  status: string;
  pendingTransfers?: number;
  failedTransfers?: number;
  syncTimestamp?: string; // datetime(ISO 8601 UTC): YYYY-MM-DDThh:mm:ssZ
}

export class GetWorkerProcessStatus extends Request<IGetWorkerProcessStatusParams, IGetWorkerProcessStatusResult> {
  constructor(params: IGetWorkerProcessStatusParams) {
    super('getWorkerProcessStatus', params);
  }
}
